import Footer from '@/entry/js-footer'
import { initMarqueeAnimation } from '@/scripts/optional/marquee'
import {
	handleBundle,
	handleMainSlider,
} from '@/scripts/product/product-bundle'
import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'
import { Observer } from 'gsap/Observer'
import { handleAnnouncementBar } from '@/scripts/optional/announcement-bar'
import { blogPage } from '@/scripts/optional/blog-page'
import { handleBaseSlider } from '@/scripts/optional/base-slider'
import { handleUpsellSlider } from '@/scripts/optional/upsell-slider'
import { initReploAtcBridge } from '@/scripts/optional/replo-atc-bridge'
import { initCookieBannerParts } from '@/entry/cookie'

document.addEventListener('DOMContentLoaded', () => {
	new Footer()
	handleUpsellSlider()

	//Marquee Animation
	initMarqueeAnimation()

	handleAnnouncementBar()

	handleBaseSlider()
	handleMainSlider()
	handleBundle()
	initReploAtcBridge()

	initCookieBannerParts()

	// ;(() => {
	// 	gsap.registerPlugin(Observer)
	// 	const STORAGE_KEY = 'pvolve_loader_seen'
	// 	const loader = document.querySelector(
	// 		'.loader-overlay'
	// 	) as HTMLElement | null
	// 	if (!loader) return

	// 	const hasSeenLoader = localStorage.getItem(STORAGE_KEY) === 'true'

	// 	if (hasSeenLoader) {
	// 		loader.style.display = 'none'
	// 		loader.classList.add('loaded')
	// 		return
	// 	}
	// 	if ('scrollRestoration' in history) {
	// 		history.scrollRestoration = 'manual'
	// 	}
	// 	window.scrollTo(0, 0)

	// 	const scrollObserver = Observer.create({
	// 		type: 'wheel,touch,scroll,pointer',
	// 		preventDefault: true,
	// 		allowClicks: true,
	// 	})

	// 	localStorage.setItem(STORAGE_KEY, 'pending')

	// 	const heroVideo = document.querySelector(
	// 		'.section--hero ucoast-video'
	// 	) as any

	// 	const heroText = new SplitText(
	// 		'.section--hero .banner-content__title',
	// 		{
	// 			type: 'lines',
	// 			mask: 'lines',
	// 			linesClass: 'hero-line',
	// 		}
	// 	)

	// 	let hasStarted = false

	// 	const tl = gsap.timeline({
	// 		paused: true,
	// 		defaults: { ease: 'power4.out' },
	// 		onComplete: () => {
	// 			localStorage.setItem(STORAGE_KEY, 'true')
	// 			loader.classList.add('loaded')
	// 			if (scrollObserver) {
	// 				scrollObserver.kill()
	// 			}
	// 		},
	// 	})

	// 	tl.fromTo(
	// 		'.loader-title',
	// 		{ yPercent: 300 },
	// 		{ yPercent: -50, duration: 2.2 }
	// 	)
	// 		.to('.loader-title', { autoAlpha: 1 }, '<0.5')
	// 		.to(
	// 			'.loader-title',
	// 			{ autoAlpha: 0, duration: 1.5 },
	// 			'+=0.6'
	// 		)
	// 		.to('.loader-overlay', { autoAlpha: 0, duration: 0.8 }, '>.2')
	// 		.fromTo(
	// 			heroText.lines,
	// 			{ y: 120, autoAlpha: 0 },
	// 			{
	// 				y: 0,
	// 				autoAlpha: 1,
	// 				stagger: 0.1,
	// 				duration: 1.5,
	// 			},
	// 			'<'
	// 		)
	// 		.fromTo(
	// 			'.section--hero .button',
	// 			{ y: 120, autoAlpha: 0 },
	// 			{
	// 				y: 0,
	// 				autoAlpha: 1,
	// 				duration: 1.2,
	// 				onComplete: () => {
	// 					if ('scrollRestoration' in history) {
	// 						history.scrollRestoration = 'auto'
	// 					}
	// 				},
	// 			},
	// 			'<'
	// 		)

	// 	const startTimeline = () => {
	// 		if (hasStarted) return
	// 		hasStarted = true
	// 		tl.play()
	// 	}

	// 	if( !heroVideo ) startTimeline();

	// 	heroVideo.onPlay = () => {
	// 		startTimeline()
	// 	}

	// 	setTimeout(() => {
	// 		if (!hasStarted) {
	// 			startTimeline()
	// 		}
	// 	}, 20000)
	// })();
	// blogPage();
})
